import { useTranslation } from "react-i18next";
import PermissionsTableBody from "./PermissionsTableBody";
import { useEffect, useState } from "react";
import axios, { AxiosError } from "axios";
import { useSelector } from "react-redux";
import { PermissionUser } from "@/types/globalTypes";
import { Skeleton } from "../ui/skeleton";

export default function PermissionsTable() {
    const { t } = useTranslation();
    const baseUrl = import.meta.env.VITE_BASE_URL;
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const [usersData, setUsersData] = useState<PermissionUser[]>([]);
    const [loading, setLoading] = useState(false);

    async function fetchUsersData() {
        setLoading(true);
        try {
            const response = await axios.get(`${baseUrl}/api/dashboard/users/all`, {
                headers: {
                    Authorization: token,
                },
            });

            if (response.data.success) {
                setUsersData(response.data.users);
            } else {
                console.error("Failed to fetch users data:", response.data.error);
            }

        } catch (error) {
            const axiosError = error as AxiosError<{ error: string }>;
            console.error("Error fetching users data:", axiosError);
            console.error("Details:", axiosError.response?.data?.error || "Unknown error");
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        if (!token) return
        fetchUsersData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    if (loading) {
        return (
            <>
                <Skeleton className="h-32 w-full mt-32 dark:bg-gray-300" />

            </>
        )
    }
    return (
        <>
            <div className="my-10">
                <h2 className="text-xl font-semibold">
                    {t("permissions.manage")}
                </h2>
            </div>
            <div className=" overflow-x-auto whitespace-nowrap text-center">
                <table className="w-full text-sm  text-gray-500 bg-white ">
                    <thead className="text-xs  text-gray-700 uppercase bg-white selection:bg-none ">
                        <tr className="border-b">
                            <th className="px-6 text-start py-3">
                                {t("permissions.name")}
                            </th>
                            <th className="px-6 text-start py-3 ">
                                {t("permissions.email")}
                            </th>
                            <th className="px-6 text-start py-3 ">
                                {t("permissions.phone")}
                            </th>
                            <th className="px-6 text-start py-3  ">
                                {t("permissions.role")}
                            </th>
                            <th className="px-6 text-start py-3  ">
                                {t("permissions.branch")}
                            </th>
                            <th className="px-6 text-start py-3  ">
                                {t("permissions.status")}
                            </th>
                            <th className="px-6 text-start py-3  ">
                                {t("permissions.action")}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {usersData.map((user) => (
                            <PermissionsTableBody key={user._id} userData={user} />
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )
}
